import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {SearchHomeComponent} from './search-home/search-home.component';
import {SearchResultComponent} from './search-result/search-result.component';
import {CompanyPscDetailsComponent} from './company-psc-details/company-psc-details.component';

const routes: Routes = [
  { path: '', component: SearchHomeComponent },
  { path: 'results', component: SearchResultComponent },
  { path: 'results/:companyId', component: CompanyPscDetailsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SearchRoutingModule {}
